// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

import Home from './pages/Home';
import SignIn from './pages/SignIn';
import './App.css';

function ScrollRouterWrapper() {
  const location = useLocation();

  useEffect(() => {
    const scrollToId = {
      "/": "top",
      "/tickets": "ticket-section",
      "/news": "news-section",
      "/contact": "contact-us",
      "/about": "about-us",
      "/buy": "ticket-section", // or use 'buy-section' if different
    }[location.pathname];

    if (scrollToId) {
      setTimeout(() => {
        const target = document.getElementById(scrollToId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (scrollToId === 'top') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return <Home />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<SignIn />} />
        {/* All main pages handled by ScrollRouterWrapper */}
        <Route path="/" element={<ScrollRouterWrapper />} />
        <Route path="/tickets" element={<ScrollRouterWrapper />} />
        <Route path="/news" element={<ScrollRouterWrapper />} />
        <Route path="/contact" element={<ScrollRouterWrapper />} />
        <Route path="/about" element={<ScrollRouterWrapper />} />
        <Route path="/buy" element={<ScrollRouterWrapper />} />
      </Routes>
    </Router>
  );
}

export default App;
